"use client";

// TODO: Truborepoが対応したらSCSSに変更する
import Link from "next/link";
// @ts-ignore
import styles from "./../styles/components/parts/Button.module.css";

export default function ButtonDefault({
  className,
  label,
  size = "md",
  color = "primary",
  type = "button",
  icon,
  disabled,
  action,
  href,
  target,
}: {
  className?: string;
  label: string;
  size?: "sm" | "md";
  color?: "primary" | "secondary" | "tertiary"| "tertiarySquare" | "black" | "fav";
  type?: "button" | "submit" | "reset";
  icon?: string;
  disabled?: boolean;
  action?: () => void;
  href?: string;
  target?: string;
}) {
  const iconClassName = icon ? `icon icon-${icon}` : "";
  return !disabled && href ? (
    <Link
      className={`${styles.buttonDefault} ${
        color === "primary" && styles.buttonDefault__primary
      } ${color === "secondary" && styles.buttonDefault__secondary} ${
        color === "tertiary" && styles.buttonDefault__tertiary
      } ${
        color === "tertiarySquare" && styles.buttonDefault__tertiarySquare
      } ${color === "black" && styles.buttonDefault__black} ${
        size === "sm" && styles.buttonDefault__sm
      } ${className}`}
      type={type}
      href={href}
      target={target}
    >
      {label}
    </Link>
  ) : (
    <button
      className={`${styles.buttonDefault} ${
        color === "primary" && styles.buttonDefault__primary
      } ${color === "secondary" && styles.buttonDefault__secondary}
      ${color === "tertiarySquare" && styles.buttonDefault__tertiarySquare}
      ${color === "tertiary" && styles.buttonDefault__tertiary}
      ${color === "fav" && styles.buttonDefault__fav}
      ${color === "black" && styles.buttonDefault__black} ${
        size === "sm" && styles.buttonDefault__sm
      } ${className}`}
      type={type}
      disabled={disabled}
      onClick={action}
    >
      {icon && <span className={iconClassName}></span>}
      {label}
    </button>
  );
}
